<template>
<div>
  <el-dialog title="解决措施" :visible.sync="dialogVisible" width="1000" :close-on-click-modal="false" @close="onClose">
    <div v-loading="loading" class="speech-container">
      <template v-if="speechData && speechData.id">
        <!-- 基本信息 -->
        <el-card class="speech-card" shadow="never">
          <div slot="header" class="card-header">
            <span>基本信息</span>
          </div>
          <el-descriptions :column="1" size="mini" border :label-style="{width: '100px'}">
            <el-descriptions-item label="房产">
              <span class="speech-text" v-if="speechData.house_name">{{ speechData.house_name }}</span>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="欠费大类">
              <span v-if="speechData.arrears_big_type">{{ speechData.arrears_big_type }}</span>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="欠费类型">
              <span v-if="speechData.arrears_type">{{ speechData.arrears_type }}</span>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="责任部门">
              <span v-if="speechData.belong_department">{{ speechData.belong_department }}</span>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
<!--            <el-descriptions-item label="业主诉求">-->
<!--              <div class="speech-text" v-if="speechData.question">{{ speechData.question }}</div>-->
<!--              <span v-else class="text-empty">暂无</span>-->
<!--            </el-descriptions-item>-->
            <el-descriptions-item label="业主原话">
              <div class="speech-text" v-if="speechData.owner_original_words">{{ speechData.owner_original_words }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="欠费原因">
              <div class="speech-text" v-if="speechData.arrears_reason">{{ speechData.arrears_reason }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="关键词">
              <div class="speech-text" v-if="speechData.keyword">{{ speechData.keyword }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- AI 分析 -->
        <el-card class="speech-card" shadow="never">
          <div slot="header" class="card-header">
            <span>AI 分析</span>
          </div>
          <el-descriptions :column="2" size="mini" border>
            <el-descriptions-item label="分类原因" :span="2">
              <div class="speech-text" v-if="speechData.classify_reason">{{ speechData.classify_reason }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="置信度">
              <el-tag v-if="speechData.confidence !== undefined && speechData.confidence !== null" :type="confidenceType" size="mini">{{ speechData.confidence }}/10</el-tag>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="缴费意向">
              <el-tag v-if="speechData.payment_intention !== undefined && speechData.payment_intention !== null" :type="paymentIntentionType" size="mini">{{ speechData.payment_intention }}/10</el-tag>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="缴费意向说明" :span="2">
              <div class="speech-text" v-if="speechData.payment_intention_desc">{{ speechData.payment_intention_desc }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 解决措施 -->
        <el-card class="speech-card" shadow="never">
          <div slot="header" class="card-header">
            <span>解决措施</span>
          </div>
          <div class="speech-text" style="padding: 0 10px 10px;" v-if="speechData.solution_measure">{{ speechData.solution_measure }}</div>
          <span v-else class="text-empty" style="padding: 0 10px 10px;">暂无</span>
        </el-card>

        <!-- 参考话术 -->
        <el-card class="speech-card" shadow="never">
          <div slot="header" class="card-header">
            <span>参考话术</span>
          </div>
          <el-descriptions :column="1" size="mini" border :label-style="{width: '100px'}">
            <el-descriptions-item label="话术要点">
              <div class="speech-text" v-if="speechData.work_key_point">{{ speechData.work_key_point }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="话术1(温和)">
              <div class="speech-text" v-if="speechData.words_mild">{{ speechData.words_mild }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="话术2(理性)">
              <div class="speech-text" v-if="speechData.words_rational">{{ speechData.words_rational }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
            <el-descriptions-item label="话术3(正式)">
              <div class="speech-text" v-if="speechData.words_formal_notice">{{ speechData.words_formal_notice }}</div>
              <span v-else class="text-empty">暂无</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 法律条文 -->
        <el-card class="speech-card" shadow="never">
          <div slot="header" class="card-header">
            <span>法律条文</span>
          </div>
          <div class="speech-text" style="padding: 0 10px 10px;" v-if="speechData.legal_clause">{{ speechData.legal_clause }}</div>
          <span v-else class="text-empty" style="padding: 0 10px 10px;">暂无</span>
        </el-card>
      </template>

      <!-- 无数据 -->
      <el-empty v-if="!loading && (!speechData || !speechData.id)" description="暂无话术数据"></el-empty>
    </div>

    <template slot="footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </template>
  </el-dialog>
</div>
</template>


<script>
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "HouseCategorySpeech",
  data() {
    return {
      dialogVisible: false,
      ch_md5: "",
      loading: false,
      speechData: {},
    }
  },
  computed: {
    confidenceType() {
      const c = this.speechData.confidence || 0;
      if (c >= 8) return 'success';
      if (c >= 5) return 'warning';
      return 'danger';
    },
    paymentIntentionType() {
      const c = this.speechData.payment_intention || 0;
      if (c >= 8) return 'success';
      if (c >= 5) return 'warning';
      return 'danger';
    }
  },
  methods: {
    show(ch_md5) {
      this.dialogVisible = true;
      this.ch_md5 = ch_md5;
      this.fetchData();
    },
    hide() {
      this.dialogVisible = false;
      this.ch_md5 = "";
      this.speechData = {};
    },
    onClose() {
      this.speechData = {};
      this.ch_md5 = "";
    },
    parseAiData(str) {
      if (!str) return {};
      if (typeof str === 'object') return str;
      try {
        return JSON.parse(str);
      } catch (e) {
        console.error("解析AI分类数据失败", e);
        return {};
      }
    },
    fetchData() {
      const that = this;
      that.loading = true;
      ButlerHttp.post("LegalHouse/getCfInfo", { ch_md5: that.ch_md5 }, res => {
        that.loading = false;
        if (res && res.code && res.data) {
          // 外层：房产、欠费类型、业主诉求等；data 字段为 JSON 字符串，内含话术与AI分析
          const raw = res.data;
          const inner = that.parseAiData(raw.data);
          const aiInfo = inner.data || {};
          that.speechData = {
            id: raw.id,
            house_name: raw.house_name,
            arrears_big_type: raw.arrears_big_type,
            arrears_type: raw.arrears_type,
            belong_department: raw.belong_department,
            question: raw.question,
            // 内层 data 对象
            keyword: aiInfo.keyword,
            owner_original_words: aiInfo.owner_original_words,
            arrears_reason: aiInfo.arrears_reason,
            solution_measure: aiInfo.solution_measure,
            work_key_point: aiInfo.work_key_point,
            words_mild: aiInfo.words_mild,
            words_rational: aiInfo.words_rational,
            words_formal_notice: aiInfo.words_formal_notice,
            legal_clause: aiInfo.legal_clause,
            // AI 分析（中文键）
            confidence: inner['置信度'],
            classify_reason: inner['分类原因'],
            payment_intention: inner['缴费意向'],
            payment_intention_desc: inner['缴费意向说明'],
          };
        } else {
          that.speechData = {};
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
>>>.el-dialog__body{
  padding: 0 20px;
}
.speech-container{
  overflow-y: auto;
  height: 60vh;
}
.speech-card {
  margin-bottom: 20px;

  >>>.el-card__header{
    padding: 5px 20px;
    background-color: cornflowerblue;
    color: #fff;
  }
  >>>.el-card__body{
    padding: 0;
  }

  .card-header {
    font-weight: bold;
    font-size: 14px;
  }
}

.speech-text {
  white-space: pre-wrap;
  line-height: 1.8;
  color: #303133;
}

.text-empty {
  color: #c0c4cc;
}

.text-warn {
  color: #e6a23c;
}

.text-mono {
  font-family: monospace;
  font-size: 12px;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/ai/HouseCategorySpeech.vue